import React from 'react';
import { connect } from 'react-redux';
import TabPanes from '@/components/tabs/TabPanes';
import RequestDatasetsTable from '../datasets/containers/RequestDatasetsTable';
import RequestDatasetCards from '../datasets/containers/RequestDatasetCards';
import { updateRequestSource } from '../actions';
import { requestSources } from '../constants';
import { newRequest, resolveRequestWorkflow } from '../state/state';
import RequestCohortCards from '../cohorts/containers/RequestCohortCards';
import RequestCohortsTable from '../cohorts/containers/RequestCohortsTable';

const tabs = {
  [requestSources.DATASET]: { compact: RequestDatasetCards, component: RequestDatasetsTable },
  [requestSources.COHORT]: { compact: RequestCohortCards, component: RequestCohortsTable },
};

const SelectRequestSource = ({
  category,
  changeSource,
  code,
  compact,
  includeCohorts,
  includeDatasets,
  tab,
}) => {
  const sources = [];
  if (includeDatasets) { sources.push(requestSources.DATASET); }
  if (includeCohorts) { sources.push(requestSources.COHORT); }

  const onRender = (name, className) => {
    const item = tabs[name];
    const Content = compact ? item.compact : item.component;
    return { content: (<Content className={className} category={category} code={code} />) };
  };

  if (sources.length < 2) { return onRender(sources[0], 'aridhia-dar-container').content; }

  return (
    <TabPanes
      activeIndex={sources.indexOf(tab)}
      className="aridhia-dar-container aridhia-select-request-source"
      secondary
      pointing
      entity="request"
      onRender={onRender}
      tabs={sources.map((name) => ({ name }))}
      indexes={[0, 1]}
      onTabChange={(e, { activeIndex }) => changeSource(category, code, sources[activeIndex])}
    />
  );
};

const mapStateToProps = ({
  auth: { role: { permissions: { datasets, cohorts } } },
  requests: { requests },
  workflows: { workflows },
}, ownProps) => {
  const { request } = resolveRequestWorkflow(requests, workflows, ownProps, newRequest(ownProps));
  return ({
    tab: request.request_source,
    includeDatasets: datasets.read,
    includeCohorts: cohorts.read,
  });
};

const mapDispatchToProps = {
  changeSource: updateRequestSource,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectRequestSource);
